import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ModelsSelectService {
  api = environment.api;

  constructor( private http: HttpClient ) { }

  listBrands() {
    return this.http.get(this.api+`/marca-modelo`);
  }

  addBrands(raw) {
    return this.http.post(this.api+`/marca-modelo`, raw);
  }
}
